import type { Content } from '../types'

export const replaceContents = <T extends Content['type']>(
  contents: Content[],
  type: T,
  next: Extract<Content, { type: T }>[],
  position: 'start' | 'end' = 'end',
): Content[] => {
  const others = contents.filter((item) => item.type !== type)

  return position === 'start' ? [...next, ...others] : [...others, ...next]
}
